var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout",class:_vm.showNav ? 'has-nav' : ''},[(_vm.showNav)?_c('div',{staticClass:"layout-header-wrapper"},[_c('LayoutHeader')],1):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }